import { c as _c } from "react/compiler-runtime";
import { Logo } from '@petsmart-ui/sparky';
import { SideDrawer } from '@libs/shared-ui';
import { trackNavigationHeaderClick } from '../../../../shared';
import type { MenuQuickLink, PrimaryNavigationItem } from '../../../../types';
import { NestedLevel } from './nested-level';
import { QuickLinks } from './quick-links';
import { Level, type LevelEntry } from './shared';
import { useDrawer } from './use-drawer';
import './drawer.scss';
type DrawerProps = {
  isOpen: boolean;
  items: PrimaryNavigationItem[];
  onCloseAll: () => void;
  onOpenChange: (isOpen: boolean) => void;
  onOpenChangeComplete: (isOpen: boolean) => void;
  quickLinks: MenuQuickLink[];
};
export function Drawer(t0) {
  const $ = _c(39);
  const {
    isOpen,
    items,
    onCloseAll,
    onOpenChange,
    onOpenChangeComplete,
    quickLinks
  } = t0;
  let t1;
  if ($[0] !== onCloseAll || $[1] !== onOpenChange || $[2] !== onOpenChangeComplete) {
    t1 = {
      onCloseAll,
      onOpenChange,
      onOpenChangeComplete
    };
    $[0] = onCloseAll;
    $[1] = onOpenChange;
    $[2] = onOpenChangeComplete;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    activeNode,
    closeAll,
    closeButtonRef,
    closeChild,
    handleOpenChange,
    handleOpenChangeComplete,
    openNode
  } = useDrawer(t1);
  let t2;
  if ($[4] !== closeAll || $[5] !== items || $[6] !== openNode) {
    let t3;
    if ($[8] !== closeAll || $[9] !== openNode) {
      t3 = item => item.kind === "link" ? {
        href: item.href,
        id: item.id,
        label: item.title,
        onSelect: () => {
          trackNavigationHeaderClick({
            selection: [item.title],
            linkUrl: item.href,
            navSection: "main nav"
          });
          closeAll();
        },
        openInNewTab: item.openInNewTab,
        sale: item.emphasis === "promotion"
      } : {
        id: item.id,
        label: item.title,
        onSelect: trigger => openNode(item, trigger),
        sale: item.emphasis === "promotion"
      };
      $[8] = closeAll;
      $[9] = openNode;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = items.map(t3);
    $[4] = closeAll;
    $[5] = items;
    $[6] = openNode;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const rootEntries = t2;
  let t3;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <SideDrawer.Title className="mobile-menu-drawer__title">Main menu</SideDrawer.Title>;
    t4 = <Logo href="/" className="mobile-menu-drawer__logo" />;
    $[11] = t3;
    $[12] = t4;
  } else {
    t3 = $[11];
    t4 = $[12];
  }
  let t5;
  if ($[13] !== closeButtonRef) {
    t5 = <SideDrawer.Header closeRef={closeButtonRef} className="mobile-menu-drawer__header">{t3}{t4}</SideDrawer.Header>;
    $[13] = closeButtonRef;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== rootEntries) {
    t6 = <Level root={true} entries={rootEntries} label="Main menu" />;
    $[15] = rootEntries;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== closeAll || $[18] !== quickLinks) {
    t7 = <div className="mobile-menu-drawer__quick-links"><QuickLinks links={quickLinks} onLinkSelect={closeAll} /></div>;
    $[17] = closeAll;
    $[18] = quickLinks;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = <SideDrawer.Body>{t6}{t7}</SideDrawer.Body>;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== closeAll || $[24] !== closeButtonRef || $[25] !== handleOpenChange || $[26] !== handleOpenChangeComplete || $[27] !== isOpen || $[28] !== t5 || $[29] !== t8) {
    t9 = <SideDrawer className="mobile-menu-drawer" initialFocus={closeButtonRef} isOpen={isOpen} onClose={closeAll} onOpenChange={handleOpenChange} onOpenChangeComplete={handleOpenChangeComplete}>{t5}{t8}</SideDrawer>;
    $[23] = closeAll;
    $[24] = closeButtonRef;
    $[25] = handleOpenChange;
    $[26] = handleOpenChangeComplete;
    $[27] = isOpen;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  let t10;
  if ($[31] !== activeNode || $[32] !== closeAll || $[33] !== closeChild || $[34] !== isOpen) {
    t10 = activeNode && <NestedLevel node={activeNode} rootIsOpen={isOpen} selectionPath={[activeNode.title]} onBack={closeChild} onCloseAll={closeAll} />;
    $[31] = activeNode;
    $[32] = closeAll;
    $[33] = closeChild;
    $[34] = isOpen;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== t10 || $[37] !== t9) {
    t11 = <>{t9}{t10}</>;
    $[36] = t10;
    $[37] = t9;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  return t11;
}